/* eslint-disable @reatom/unit-naming-rule */
import { useMemo } from 'react'
import styled, { css } from 'styled-components'

import { PairLink } from '@root/entities/pair/ui/common'
import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import { reatomCreatorPairsTable } from '../../atoms/reatom-creator-pairs-table'

import type { CreatorPairsTableModel } from '../../atoms/reatom-creator-pairs-table'
import type { Address } from '@root/entities/address/Address'
import type { Network } from '@root/entities/network'
import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

export type Props = {
  creatorAddress: Address
  network: Network.Network
  model?: CreatorPairsTableModel
} & ClassNameProps

export const CreatorPairsTable: React.FC<Props> = ({
  className,
  creatorAddress,
  network,
  model: initialModel,
}) => {
  const model = useMemo(
    () =>
      initialModel ??
      reatomCreatorPairsTable({
        creatorAddress,
        network,
      }),
    [creatorAddress, initialModel, network],
  )

  return (
    <AppDataTable
      css={css`
        height: 100%;
      `}
      model={model}
      className={className}
      rowHeight={40}
      renderBackgroundLink={(args) => <PairLinkWrapper pair={args.data} />}
    />
  )
}

const PairLinkWrapper = styled(PairLink<PairModel>)`
  position: absolute;
  inset: 0;
  z-index: 0;
`
